window._ = require('lodash');
require('bootstrap/js/dist/dropdown')

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

Bugsnag.start({
    apiKey: process.env.MIX_BUGSNAG_API_KEY,
    appVersion: process.env.MIX_APP_VERSION,
    plugins: [new BugsnagPluginVue()]
})

// Plugins
import './plugins/Dayjs';

import Vue from 'vue';
Bugsnag
    .getPlugin('vue')
    .installVueErrorHandler(Vue);

import App from './vue/App';

import Vuex from 'vuex';
Vue.use(Vuex);

import router from './vue/router/router';

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue);

import Snotify, { SnotifyPosition } from 'vue-snotify'

const options = {
    toast: {
        position: SnotifyPosition.leftBottom,
        timeout: 8000
    }
}

Vue.use(Snotify, options);

import 'vue-loading-overlay/dist/vue-loading.css';

import i18n from './i18n'

const progressBarOptions = {
    color: '#23C426',
    failedColor: '#db2525',
    thickness: '5px',
    transition: {
        speed: '0.2s',
        opacity: '0.6s',
        termination: 300
    },
};
import VueProgressBar from 'vue-progressbar'
Vue.use(VueProgressBar, progressBarOptions);


import vSelect from 'vue-select'
Vue.component('v-select', vSelect)


// Layouts
import DashboardLayout from './vue/layouts/Dashboard/Dashboard';
Vue.component('dashboard-layout', DashboardLayout);

import AuthLayout from './vue/layouts/Auth/Auth';
Vue.component('auth-layout', AuthLayout);

import ErrorLayout from './vue/layouts/Error/Error';
Vue.component('error-layout', ErrorLayout);


const store = require('./vue/store/store.js').default;

import LaravelVueValidator from './vue/components/Includes/ErrorComponent/Init';
Vue.use(LaravelVueValidator);

Vue.component('pagination', require('laravel-vue-pagination'));

//VideoJs
let videojs = require('video.js');
require('@silvermine/videojs-quality-selector')(videojs);
require('@videojs/http-streaming');

//require('./plugins/videojs/videojs-watermark');


Vue.mixin({
   methods: {
       convertBytesToHumanReadable: function (bytes, decimals = 2) {
           if (bytes === 0) return '0 Bytes';

           const k = 1024;
           const dm = decimals < 0 ? 0 : decimals;
           const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

           const i = Math.floor(Math.log(bytes) / Math.log(k));

           return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
       }
   }
});

/* eslint-disable no-new */
let vue = new Vue({
    el: '#app',
    router,
    store,
    i18n,
    components: {
        App
    },
    template: '<App/>'
})

export { vue };
